import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/tocV3/268V_Icon.png'
import _imports_1 from '../../../assets/tocV3/Vector.png'
import _imports_2 from '../../../assets/tocV3/headGuaranteeArrow.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-386d20a0")

_pushScopeId("data-v-386d20a0")
const _hoisted_1 = { class: "tocV3_topText" }
const _hoisted_2 = { class: "tocV3_topText_flex" }
const _hoisted_3 = {
  key: 0,
  class: "tocV3_topText_xny"
}
const _hoisted_4 = {
  key: 0,
  class: "tocV3_banner_cheKuang_main"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("b", null, "温馨提示：本报告检测内容仅供参考，不可直接作为车辆交易凭证。", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 如您参考此报告购车，268V不承担任何检测失误责任。 ")
const _hoisted_7 = { class: "tocV3_rectangle_cardTitle" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "tocV3_rectangle_resTit" }, [
  /*#__PURE__*/_createVNode("i", { class: "tocV3_rectangle_resTit_line leftLine" }),
  /*#__PURE__*/_createVNode("span", { class: "tocV3_rectangle_resTit_txt" }, " 此车已经过268V认证检测 "),
  /*#__PURE__*/_createVNode("i", { class: "tocV3_rectangle_resTit_line rightLine" })
], -1)
const _hoisted_10 = { class: "tocV3_rectangle_resBox" }
const _hoisted_11 = {
  key: 0,
  class: "reportLevelDesc"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "vector",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "arrowRightGray",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_14 = { class: "buyCarTip" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: ["tocV3_headTip", {"tocV3_hcbg": _ctx.state.reportMsg.RpHC(),"tocV3_ck_padding": _ctx.state.reportMsg.RpCK()}]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: ["tocV3_topText_one", {"tocV3_hcStyle": _ctx.state.reportMsg.RpHC()}]
          }, _toDisplayString(_ctx.state.brandName), 3),
          (_ctx.state.isXNY)
            ? (_openBlock(), _createBlock("div", _hoisted_3, "新能源"))
            : _createCommentVNode("", true),
          (_ctx.state.productName.length > 0)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: ["tocV3_topText_two", {"tocV3_hcStyle": _ctx.state.reportMsg.RpHC()}]
              }, _toDisplayString(_ctx.state.productName), 3))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", {
          class: ["tocV3_topText_small", {"tocV3_hcStyle": _ctx.state.reportMsg.RpHC()}]
        }, _toDisplayString(_ctx.state.modelName), 3),
        _createVNode("div", {
          class: ["tocV3_topText_small", {"tocV3_hcStyle": _ctx.state.reportMsg.RpHC()}]
        }, "VIN: " + _toDisplayString(_ctx.state.vin), 3),
        _createVNode("div", {
          class: ["tocV3_topText_small_shallow", {"tocV3_hcStyle": _ctx.state.reportMsg.RpHC()}]
        }, "*车型信息仅供参考，请以实车为准", 2)
      ]),
      (_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("img", {
              src: require('../../../assets/tocV3/tipIcon.png')
            }, null, 8, ["src"]),
            _hoisted_5,
            _hoisted_6
          ]))
        : (_openBlock(), _createBlock("div", {
            key: 1,
            class: _ctx.getToCV3RectangleStyle()
          }, [
            _createVNode("div", {
              class: _ctx.getToCV3RectangleLineStyle()
            }, [
              _createVNode("div", {
                class: _ctx.getToCV3RectangleWhiteLineStyle()
              }, [
                _createVNode("div", {
                  class: {"tocV3_rectangle_wenli_gray": _ctx.state.reportMsg.Rp499(),"tocV3_rectangle_wenli_orange": _ctx.state.reportMsg.Rp699()}
                }, [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("span", {
                      class: ["toc_ui__headTip_content_report_num", {"report_num_699_style": _ctx.state.reportMsg.Rp699()}]
                    }, "NO." + _toDisplayString(_ctx.state.reportCode) + " " + _toDisplayString(_ctx.state.reportGenDate ? `| ${_ctx.state.reportGenDate.replace(/-/g,'.')}` : ''), 3)
                  ]),
                  _createVNode("div", {
                    class: ["tocV3_rectangle_res", {"warn": _ctx.state.isFire || _ctx.state.isWater || _ctx.state.accidentFlag === 2 }]
                  }, [
                    _hoisted_9,
                    _createVNode("ul", _hoisted_10, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportResultList, (item, index) => {
                        return (_openBlock(), _createBlock("li", {
                          class: "tocV3_rectangle_resBox_item",
                          key: index
                        }, [
                          _createVNode("img", {
                            src: item.isErr === 0 ? item.baseSrc : (item.isErr === 1 ? item.src : item.otherSrc),
                            alt: ""
                          }, null, 8, ["src"]),
                          _createVNode("p", {
                            class: ["tocV3_rectangle_resBox_item_txt", {"tocV3_rectangle_resBox_item_txt_warn": item.isErr==1 ,
                                        "tocV3_rectangle_resBox_item_txt_warnGray": item.isErr==2
                                        }]
                          }, _toDisplayString(item.name), 3)
                        ]))
                      }), 128))
                    ]),
                    (_ctx.state.rankDesc)
                      ? (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.state.rankDesc), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.state.isSF)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: ["tocV3_rectangle_protect", _ctx.getToCV3RectangleProtectBorderStyle()],
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.reportMsg.RpSRZ()? _ctx.setShowProtect() : _ctx.toExplain('check')))
                      }, [
                        _createVNode("span", null, [
                          _hoisted_12,
                          _createVNode("span", {
                            class: {"tocV3_rectangle_protect_699_style": _ctx.state.reportMsg.Rp699()}
                          }, _toDisplayString(_ctx.state.promiseMsg), 3)
                        ]),
                        _hoisted_13
                      ], 2))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_popup, {
                    show: _ctx.state.showProtect,
                    "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.showProtect = $event)),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("p", {
                          class: "buyCarTipItem",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toExplain('check')))
                        }, _toDisplayString(_ctx.state.showPromiseDes), 1),
                        (_ctx.state.reportMsg.RpSRZ())
                          ? (_openBlock(), _createBlock("p", {
                              key: 0,
                              class: "buyCarTipItem",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toExplain('auth')))
                            }, " 查看《付费享1年3万公里保修说明》 "))
                          : _createCommentVNode("", true),
                        _createVNode("p", {
                          class: "canbutton",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowProtect()))
                        }, "取消")
                      ])
                    ]),
                    _: 1
                  }, 8, ["show"])
                ], 2)
              ], 2)
            ], 2)
          ], 2))
    ], 2)
  ]))
})